import kpi from '../action/kpiAction'

export const initialState = ({
  isLoading: false,
  statistics: null,
  deliveredByDrivers: null,
  deliveredByYears: null,
  deliveredByMonths: null,
  deliveredByWeekly: null,
  deliveredByProvinces: null,
  deliveredFaileds: null,
  deliveredFailedByDrivers: null,
  status: null,
})


export default function (state = initialState, action) {
  switch (action.type) {

    case kpi.TYPES.REQUEST_STATISTIC:
      return Object.assign({}, state, { statistics: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_STATISTIC_SUCCESS:
      return Object.assign({}, state, { statistics: action.payload, isLoading: false, status: null})

    // Delivered By driver
    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_DRIVER:
      return Object.assign({}, state, { deliveredByDrivers: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_DRIVER_SUCCESS:
      return Object.assign({}, state, { deliveredByDrivers: action.payload, isLoading: false, status: null})

    // Delivered By Month
    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_MONTH:
      return Object.assign({}, state, { deliveredByMonths: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_MONTH_SUCCESS:
      return Object.assign({}, state, { deliveredByMonths: action.payload, isLoading: false, status: null})

    // Delivered By Weekly
    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_WEEKLY:
      return Object.assign({}, state, { deliveredByWeekly: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_WEEKLY_SUCCESS:
      return Object.assign({}, state, { deliveredByWeekly: action.payload, isLoading: false, status: null})

    // Delivered By Year
    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_YEAR:
      return Object.assign({}, state, { deliveredByYears: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_YEAR_SUCCESS:
      return Object.assign({}, state, { deliveredByYears: action.payload, isLoading: false, status: null})

    // Delivered By Province
    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_PROVINCE:
      return Object.assign({}, state, { deliveredByProvinces: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_BY_PROVINCE_SUCCESS:
      return Object.assign({}, state, { deliveredByProvinces: action.payload, isLoading: false, status: null})

    // Delivered failed
    case kpi.TYPES.REQUEST_KPI_DELIVERED_FAILED:
      return Object.assign({}, state, { deliveredFaileds: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_FAILED_SUCCESS:
      return Object.assign({}, state, { deliveredFaileds: action.payload, isLoading: false, status: null})

    // Delivered failed
    case kpi.TYPES.REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER:
      return Object.assign({}, state, { deliveredFailedByDrivers: null, isLoading: true, status: null})

    case kpi.TYPES.REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_SUCCESS:
      return Object.assign({}, state, { deliveredFailedByDrivers: action.payload, isLoading: false, status: null})

    default:
      return state
  }
}
